export default "__VITE_ASSET__0sobj9D5__"